var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiContactUs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.793 1.293A1 1 0 015.5 1H10a1 1 0 011 1v5a.5.5 0 01-.854.354L8.793 6H5.5a1 1 0 01-1-1V2a1 1 0 01.293-.707zM10 2H5.5v3H9a.5.5 0 01.354.146l.646.647V2zM1.293 4.793A1 1 0 012 4.5h1a.5.5 0 010 1H2v3.793l.646-.647A.5.5 0 013 8.5h3.5v-1a.5.5 0 011 0v1a1 1 0 01-1 1H3.207l-1.353 1.354A.5.5 0 011 10.5v-5a1 1 0 01.293-.707z",
    fill: "#000"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--contact-us-474a4626a1b5ae439616fd06868f0adb.svg";
export { SvgIconUiContactUs as Component };